import WebApp from '@twa-dev/sdk'
import { Bell, ChevronRight, CircleHelp, CreditCard, Heart, Settings, WalletCards } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../api/client'
import { getTelegramUserId, getTelegramUsername } from '../utils/telegram'
import { useLanguage } from '../hooks/useLanguage'

export function MePage() {
  const navigate = useNavigate()
  const { t } = useLanguage()
  const user = WebApp.initDataUnsafe?.user
  const { data } = useQuery({
    queryKey: ['balance', getTelegramUserId()],
    queryFn: () => apiClient.get<{ balance: number }>('/api/user/balance', { chat_id: getTelegramUserId() }),
  })
  const items = [
    { label: t('我的关注', 'My Follows'), icon: Heart, path: '/follows' },
    { label: t('我的余额', 'Balance'), icon: WalletCards, path: '/balance', value: `${data?.balance ?? '--'} credits` },
    { label: t('USDT 充值', 'USDT Recharge'), icon: CreditCard, path: '/balance' },
    { label: t('通知', 'Notifications'), icon: Bell, path: '/notifications' },
    { label: t('设置', 'Settings'), icon: Settings, path: '/settings' },
    { label: t('帮助与反馈', 'Help & Feedback'), icon: CircleHelp, path: '/settings' },
  ]

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <header className="border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
        <div className="mx-auto flex max-w-3xl items-center gap-3 px-4 py-3">
          <button type="button" onClick={() => navigate(-1)} className="h-8 w-8 rounded-md bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200">←</button>
          <h1 className="text-base font-semibold text-gray-900 dark:text-white">{t('我的', 'Me')}</h1>
        </div>
      </header>
      <main className="mx-auto max-w-3xl space-y-4 p-4">
        <section className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800">
          {user?.photo_url ? (
            <img src={user.photo_url} alt="" className="h-12 w-12 rounded-full object-cover" />
          ) : (
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100 text-lg font-bold text-blue-700">
              {getTelegramUsername().slice(0, 1).toUpperCase()}
            </div>
          )}
          <div>
            <div className="font-semibold text-gray-900 dark:text-white">{getTelegramUsername()}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">{data?.balance ?? '--'} credits</div>
          </div>
        </section>
        <section className="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
          {items.map(({ label, icon: Icon, path, value }) => (
            <button key={label} type="button" onClick={() => navigate(path)} className="flex w-full items-center gap-3 border-b border-gray-100 px-4 py-3.5 text-left last:border-0 dark:border-gray-700">
              <Icon className="h-5 w-5 text-gray-500" />
              <span className="flex-1 text-sm font-medium text-gray-900 dark:text-white">{label}</span>
              {value && <span className="text-xs text-gray-400">{value}</span>}
              <ChevronRight className="h-4 w-4 text-gray-400" />
            </button>
          ))}
        </section>
        <p className="pb-3 pt-2 text-center text-[10px] leading-none text-gray-300 dark:text-gray-600">
          {t('开发者', 'Developer')}：
          <a
            href="https://x.com/LGG_Tokenomics"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-gray-500 dark:hover:text-gray-400"
          >
            @LGG_Tokenomics
          </a>
        </p>
      </main>
    </div>
  )
}
